<template>
    <span @click.stop="copyToClipboard" :class="sqlStatement ? 'handpointer' : ''">
        ({{ timeFormatted }} s)
    </span>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'SqlDetails',
  props: [ 'timeTaken', 'sqlStatement' ],
  components: {},
  computed: {
    timeFormatted: function () {
      return Vue.prototype.$api.formatLocaleNumber('n2', this.timeTaken);
    }
  },
  methods: {
    copyToClipboard: function () {
        if (this.sqlStatement) {
          navigator.clipboard.writeText(this.sqlStatement);
          alert("SQL Statement wurde in die Zwischenablage kopiert.")
        }
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/widgets/SqlDetails.vue